import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

const csrfToken = document.querySelector("meta[name=\"csrf-token\"]")?.content || "";
export default class MessagePreviewController extends Controller {
  static targets = ["input"];

  connect() {
    this.attachmentfiles = [];
    this.pendingAttachmentUploads = 0;
    this.quill = null;
    this.discardRecording = false;
    this.mediaRecorder = null;
    this.audioStream = null;
    this.element.addEventListener("submit", (e) => {
      e.preventDefault();
      this.submitMessageForm(this.element);
    });

    this.element.addEventListener("turbo:submit-start", (e) => {
      $(e.target).find(".chat-footer").addClass("disabled");
    });

    this.element.addEventListener("turbo:submit-end", (e) => {
      $(e.target).find(".chat-footer").removeClass("disabled");
      $(e.target)[0].reset();
      this.resetQuillInput(true);
      $("#attachment-previews").addClass("d-none");
      $("#audio-record-button").removeClass("disabled");
      $("#msgEmojiPicker").removeClass("disabled");
      $("#msgInputBox").removeClass("disabled");
      $("#messageAttachments").removeClass("disabled");
      $("#attachments_name").empty();
      $(".reply-msg").remove();
    });
  }

  resetQuillInput(focus = false) {
    const quillController =
      this.application.getControllerForElementAndIdentifier(
        this.element.querySelector("[data-controller='quill']"),
        "quill"
      );

    if (quillController) {
      quillController.clear();
      if (focus) {
        quillController.quill.focus();
      }
    }
  }

  addImageToFileField({ detail }) {
    const files = detail.files || [];

    for (const file of files) {
      this.selectFile(null, file);
    }
  }

  selectFile(e, file = false) {
    const newFiles = file ? [file] : Array.from(e.target.files);

    // show alert when try to upload the more than 5 file
    if (this.attachmentfiles.length === 0 && newFiles.length > 5) {
      this.showAlert(
        "Attachment Limit Exceeded",
        "You can upload max 5 attachments",
        "error"
      );
      return;
    }

    if (this.attachmentfiles.length + newFiles.length === 5) {
      this.disableButtons(true);
    }

    // validate total limit of file attachment
    if (this.attachmentfiles.length + newFiles.length > 5) {
      $(".show_error")
        .html("You can upload max 5 attachments")
        .addClass("text-danger");
      return;
    }
    $(".show_error").html("");

    // store newly added files into attachment state
    this.attachmentfiles.push(...newFiles);
    for (const selectedFile of newFiles) {
      this.uploadAttachment(selectedFile);
    }

    // sync attachment state with actual input field
    this.syncAttachments();

    $("#attachment-previews").removeClass("d-none");

    // display preview of new added files
    for (const file of newFiles) {
      const reader = new FileReader();
      this.createAndDisplayFilePreviewElements(file, reader);
    }
    const messages = document.getElementById("chat-history");
    setTimeout(() => {

      messages.scrollTop = messages.scrollHeight - messages.clientHeight;
    }, 400);
  }

  createAndDisplayFilePreviewElements(file, reader) {
    if (file.type.startsWith("audio/")) {
      const element = this.constructPreviews(file);
      element.classList.add("attachment-preview");
      document
        .getElementById("attachments_name")
        .insertBefore(
          element,
          document.getElementById("attachments_name").firstChild
        );
      return;
    }

    reader.onload = () => {
      const element = this.constructPreviews(file, reader);
      element.classList.add("attachment-preview");
      document.getElementById("attachments_name").appendChild(element);
    };

    reader.readAsDataURL(file);
  }

  constructPreviews(file, reader) {
    let element;
    const cancelFunction = (e) => this.removePreview(e);

    if (file.type.startsWith("audio/")) {
      element = this.createAudioElement(cancelFunction, file);
    } else if (file.type.startsWith("image/")) {
      element = this.createImageElement(cancelFunction, reader);
    } else if (file.type.startsWith("video/")) {
      element = this.createVideoElement(cancelFunction, file);
    } else {
      element = this.createDefaultElement(cancelFunction, file);
    }

    const id = generateUUID();
    file.previewId = id;
    element.dataset.id = id;
    element.dataset.filename = file.name;
    return element;
  }

  createImageElement(cancelFunction, reader) {
    let cancelUploadButton, element;
    const image = document.createElement("img");
    image.style = "background-image: url(" + reader.result + ")";
    image.classList = "bg-cover bg-center position-relative w-100 h-100 border-2 border-solid border-form-border rounded-3 bg-light-tomato";
    image.classList.add("preview-image");
    element = document.createElement("div");
    element.classList.add("attachment-image-container", "file-removal", "position-relative", "w-100px", "h-100px", "overflow-hidden");
    element.appendChild(image);
    cancelUploadButton = document.createElement("i");
    cancelUploadButton.classList.add(
      "ri-close-circle-line",
      "cancel-upload-button",
      "cursor-pointer",
      "position-absolute",
      "top-0",
      "end-0",
      "m-2",
      "text-danger",
      "fw-bolder",
      "fs-18",
      "lh-1"
    );
    cancelUploadButton.onclick = cancelFunction;
    element.appendChild(cancelUploadButton);
    return element;
  }

  createVideoElement(cancelFunction, file) {
    let cancelUploadButton, element;
    const video = document.createElement("video");
    video.classList = "bg-cover bg-center position-relative w-100 h-100 border-2 border-solid border-form-border rounded-3 bg-light-tomato";
    video.setAttribute("controls", "controls");
    video.src = file.result;
    video.classList.add("preview-video");

    // Create temporary URL from the actual File
    const objectUrl = URL.createObjectURL(file);
    video.src = objectUrl;

    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";

    // Generate thumbnail from first frame
    video.addEventListener("loadedmetadata", () => {
      if (video.duration > 0) {
        video.currentTime = Math.min(0.1, video.duration);
      }
    });

    video.addEventListener(
      "seeked",
      () => {
        try {
          const canvas = document.createElement("canvas");

          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;

          const context = canvas.getContext("2d");

          context.drawImage(
            video,
            0,
            0,
            canvas.width,
            canvas.height
          );

          video.poster = canvas.toDataURL("image/jpeg", 0.85);
        } catch (error) {
          console.error("Failed to generate video thumbnail:", error);
        }
      },
      { once: true }
    );

    video.addEventListener("error", () => {
      console.error("Unable to load video:", {
        name: file.name,
        type: file.type,
        error: video.error
      });
    });

    element = document.createElement("div");
    element.classList.add("attachment-video-container", "file-removal", "position-relative", "w-100px", "h-100px", "overflow-hidden");
    element.appendChild(video);
    cancelUploadButton = document.createElement("i");
    cancelUploadButton.classList.add(
      "ri-close-circle-line",
      "cancel-upload-button",
      "cursor-pointer",
      "position-absolute",
      "top-0",
      "end-0",
      "m-2",
      "text-danger",
      "fw-bolder",
      "fs-18",
      "lh-1"
    );
    cancelUploadButton.onclick = (e) => {
      URL.revokeObjectURL(objectUrl);
      cancelFunction(e);
    };
    element.appendChild(cancelUploadButton);
    return element;
  }

  createDefaultElement(cancelFunction, file) {
    const element = document.createElement("div");
    element.classList.add(
      "position-relative",
      "border",
      "rounded",
      "d-flex",
      "flex-column",
      "justify-content-center",
      "align-items-center",
      "overflow-hidden",
      "flex-shrink-0",
      "p-2"
    );

    // Same size as image/video
    element.style.width = "100px";
    element.style.height = "100px";

    const icon = document.createElement("i");
    icon.classList.add("ri-file-line", "fs-1", "text-primary");

    const name = document.createElement("small");
    name.classList.add("text-white", "text-center", "mx-1", "w-100");
    name.textContent = file.name;

    const cancelUploadButton = document.createElement("i");
    cancelUploadButton.classList.add(
      "ri-close-circle-line",
      "cancel-upload-button",
      "cursor-pointer",
      "position-absolute",
      "top-0",
      "end-0",
      "m-2",
      "text-danger",
      "fw-bolder",
      "fs-18",
      "lh-1"
    );
    cancelUploadButton.onclick = cancelFunction;
    element.append(icon, name, cancelUploadButton);
    return element;
  }

  createAudioElement(cancelFunction, file) {
    const wrapper = document.createElement("div");
    const id = generateUUID();

    file.previewId = id;

    wrapper.dataset.id = id;
    wrapper.dataset.filename = file.name;
    wrapper.dataset.controller = "audio-player";
    wrapper.dataset.audioPlayerUrlValue = URL.createObjectURL(file);

    wrapper.className = `
      attachment-preview
      attachment-audio-container
      attachment-audio-preview
      position-relative
      d-flex
      align-items-center
      gap-2
      rounded-3
      transparent-gradient
      p-2
      min-w-245px
    `;

    wrapper.innerHTML = `
      <!-- Skeleton -->
      <div data-audio-player-target="skeleton" class="d-flex align-items-center gap-2 p-2 rounded-3 transparent-gradient w-100 placeholder-glow">
        <span class="placeholder rounded-circle flex-shrink-0" style="width:45px;height:45px;"></span>
        <span class="placeholder flex-grow-1 rounded" style="height:36px;"></span>
      </div>

      <div data-audio-player-target="error" class="d-none d-flex align-items-center justify-content-center gap-2 p-2 rounded-3 transparent-gradient w-100 min-h-60px text-white">
        <i class="ri-error-warning-line fs-22" aria-hidden="true"></i>
        <span>Audio unavailable</span>
      </div>

      <!-- Actual player -->
      <div data-audio-player-target="player" class="d-none d-flex align-items-center gap-2 p-2 rounded-3 transparent-gradient w-100">
        <button
          class="w-45px h-45px d-grid place-items-center cursor-pointer rounded-circle border-2 border-solid border-black bg-gradient-pink flex-shrink-0"
          data-action="audio-player#toggle"
          data-audio-player-target="playButton"
          type="button">
          <svg width="20" height="20" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="black" d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z"/>
          </svg>
        </button>

        <div data-audio-player-target="waveform" class="audio-waveform flex-grow-1 min-w-0 z-0"></div>
        <span class="text-white text-end whitespace-nowrap flex-shrink-0 min-w-80px"  data-audio-player-target="duration"></span>

        <i class="ri-close-circle-line cancel-upload-button cursor-pointer position-absolute top-0 end-0 m-1 text-danger fs-18" data-action="click->message-preview#removePreview">
        </i>
      </div>
    `;

    return wrapper;
  }

  removePreview(event) {
    const target = event.target.closest(".attachment-preview");

    const previewId = target.dataset.id;
    const filename = target.dataset.filename;

    this.attachmentfiles = this.attachmentfiles.filter(file => {
      if (file.previewId) {
        return file.previewId !== previewId;
      }

      return file.name !== filename;
    });

    this.disableButtons(false);

    this.syncAttachments();
    target.remove();
    if (this.attachmentfiles.length === 0) {
      this.toggleVisibility();
    }
    $("#audio-record-button")?.removeClass("disabled");
  }

  submitMessageForm(element) {
    if (!this.attachmentsReady()) {
      this.showAlert("Upload in progress", "Please wait for all attachments to finish uploading.", "info");
      return;
    }

    const formSubmissionController =
      this.application.getControllerForElementAndIdentifier(
        element,
        "form-submission"
      );

    if (
      formSubmissionController &&
      !formSubmissionController.start()
    ) {
      return;
    }

    let button = this.element.querySelector(".message-submit-btn");
    let loader = this.element.querySelector("#sentLoader");
    button.classList.add("d-none");
    loader.classList.remove("d-none");
    let data = this.serializeForm(element);
    let params = {
      method: "post",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
      }
    };
    params["body"] = data;
    fetch(element.action, params)
      .then((r) => {
        if (r.redirected) {
          globalThis.location.href = r.url;
        }
        return r.text();
      })
      .then((response) => {
        if (response.ok) {
          this.attachmentfiles = [];
        }
        element.reset();
        this.attachmentfiles = [];
        this.clearPreviews();
        this.clearReply();
        const messages = document.getElementById("chat-history");
        $("#audio-record-button").removeClass("disabled");
        $("#msgEmojiPicker").removeClass("disabled");
        $("#msgInputBox").removeClass("disabled");
        $("#messageAttachments").removeClass("disabled");
        $("[name='message[parent_id]']").remove();
        $("#attachments_name").empty();
        $(".reply-msg").remove();
        this.resetQuillInput(true);
        Turbo.renderStreamMessage(response);
        button.classList.remove("d-none");
        loader.classList.add("d-none");
        this?.quill?.quill?.setText("");
        setTimeout(() => {
          messages.scrollTop = messages.scrollHeight - messages.clientHeight;
        }, 100);
        formSubmissionController?.finish();
      });
  }

  serializeForm = function (form) {
    let formData = new FormData(form);
    let files = this.attachmentfiles;
    $.each(files, function (ind, val) {
      formData.append("message[attachments][]", val.signedId);
    });
    formData.delete("attachments[]");
    formData.delete("attachments");
    return formData;
  };

  toggleVisibility() {
    let preview = document.getElementById("attachment-previews");
    preview.classList.toggle("d-none");
    $("#attachments_name").empty();
  }

  replyMessage(e) {
    e.preventDefault();
    const messageId = e.currentTarget?.dataset?.messageId;
    fetch(`/messages/${messageId}/reply`, {
      method: "GET",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json"
      }
    })
      .then((r) => r.json())
      .then(({ status, html_content }) => {
        if (!status) return;
        this.toggleReplyPreview(html_content || "");
      });
  }

  clearReply() {
    this.toggleReplyPreview();
  }

  toggleReplyPreview(content = "") {
    const preview = document.getElementById("reply-msg-previews");
    if (!preview) return;

    const contentBox = preview.querySelector("#reply-msg-content");
    if (!contentBox) return;

    const hasContent = content.trim().length > 0;
    preview.classList.toggle("d-none", !hasContent);
    contentBox.innerHTML = content;
  }

  clearAudioPreview() {
    this.discardRecording = true;
    if (this.mediaRecorder?.state === "recording") {
      const record = document.getElementById("audio-record-button");
      stopRecord(record, this.mediaRecorder, this.audioStream);
    }

    this.toggleAudioPreview(false);
  }

  toggleAudioPreview(showAudio) {
    $("#audio-recording-preview").toggleClass("d-none", !showAudio);
    const hasAttachments = this.attachmentfiles.length > 0;
    $("#attachment-previews").toggleClass("d-none", showAudio || !hasAttachments);
    $(".form-actions").toggleClass("d-none", showAudio);
    $("#audio-record-button").toggleClass("disabled", showAudio);
    this.updatePreviewBoxPosition(!showAudio);
  }

  addRecordedAudio(file) {
    this.selectFile(null, file);
    this.toggleAudioPreview(false);
    this.updatePreviewBoxPosition(true);
  }

  syncAttachments() {
    // Never rebuild a mobile Chrome FileList. Android content-provider handles
    // can become invalid after removal and cause net::ERR_UPLOAD_FILE_CHANGED.
    const input = document.getElementById("message_attachments");
    if (input) input.value = "";
  }

  uploadAttachment(file) {
    const input = document.getElementById("message_attachments");
    file.uploading = true;
    file.uploadFailed = false;

    this.pendingAttachmentUploads += 1;
    this.updateAttachmentSubmitState();

    const upload = new DirectUpload(file, input.dataset.directUploadUrl);
    upload.create((error, blob) => {
      file.uploading = false;
      file.uploadFailed = Boolean(error);
      file.signedId = blob?.signed_id;
      this.pendingAttachmentUploads = Math.max(0, this.pendingAttachmentUploads - 1);
      this.updateAttachmentSubmitState();

      if (error) this.showAlert("Upload failed", `${file.name} could not be uploaded. Remove it and try again.`, "error");
    });
  }

  attachmentsReady() {
    return this.pendingAttachmentUploads === 0 && this.attachmentfiles.every(file => file.signedId && !file.uploadFailed);
  }

  updateAttachmentSubmitState() {
    const button = this.element.querySelector(".message-submit-btn");
    if (button) button.disabled = this.pendingAttachmentUploads > 0;
  }

  clearPreviews() {
    let preview = document.getElementById("attachment-previews");
    preview.classList.add("d-none");
    $("#attachments_name").empty();
    $("#attachment-previews").addClass("d-none");
    $("#attachment-previews").removeClass("bottom-0");
    $("#attachment-previews")[0].style.setProperty("position", "unset");
    $(".reply-msg").remove();
    $("#audio-record-button").removeClass("disabled");
    $("#msgEmojiPicker").removeClass("disabled");
    $("#msgInputBox").removeClass("disabled");
    $("#messageAttachments").removeClass("disabled");
    this.updatePreviewBoxPosition(true);
    this.attachmentfiles = [];
    this.pendingAttachmentUploads = 0;
    const attachement = document.getElementById("message_attachments");
    if (attachement && attachement.files.length > 0) {
      attachement.value = ""; // resets file selection on clear
    }
    $(".form-actions").removeClass("d-none");
    $("#recorder").remove();
    const button = $(".message-submit-btn").clone();
    button.addClass("d-none");
    $("#attachments_name").html(button);
    this.disableButtons(false);
  }

  startAudio() {
    if (this.attachmentfiles.length >= 5) {
      this.showAlert("Attachment Limit Exceeded", "You can upload max 5 attachments", "error");
      return;
    }

    this.audio();
  }

  audio() {
    let record = document.getElementById("audio-record-button");
    // let messageAttachments = document.getElementById("message_attachments");:
    let recording = false;
    if (navigator.mediaDevices.getUserMedia) {
      const constraints = { audio: true };
      let chunks = [];
      const onSuccess = (stream) => {
        this.discardRecording = false;
        this.audioStream = stream;

        // Open audio modal only after microphone access is granted
        this.toggleAudioPreview(true);

        const audioTypes = ["audio/wav", "audio/mp4", "audio/mp3", "audio/webm"];
        let audioType = audioTypes.find(type => MediaRecorder.isTypeSupported(type)) ?? "audio/webm";
        const mediaRecorder = new MediaRecorder(stream, { mimeType: audioType });
        this.mediaRecorder = mediaRecorder;
        startRecord(record, mediaRecorder);
        recording = !recording;
        let stopRecordAudio = document.getElementById("stop-record");
        stopRecordAudio.onclick = function (event) {
          event.preventDefault();
          if (recording) {
            stopRecord(record, mediaRecorder, stream);
          } else {
            startRecord(record, mediaRecorder);
          }
          recording = !recording;
        };
        mediaRecorder.onstop = () => {
          if (this.discardRecording) {
            this.discardRecording = false;
            chunks = [];
            return;
          }

          const blob = new Blob(chunks, { type: audioType });
          chunks = [];

          const extension = audioType.split("/")[1]?.split(";")[0] || "webm";
          const file = new File([blob], `audio-${Date.now()}.${extension}`, {
            type: audioType,
            lastModified: Date.now()
          });

          $("#recorder").remove();
          this.addRecordedAudio(file);
        };
        mediaRecorder.ondataavailable = function (e) {
          chunks.push(e.data);
        };
      };
      let onError = function (err) {
        throwError(err);
      };
      navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    }
  }

  submitIfValid(event) {
    $("#attachment-previews").addClass("d-none");
    const length = Number.parseInt(this.inputTarget.dataset.length || 0, 10);
    if (
      length === 0 &&
      this.attachmentfiles.length === 0 &&
      event.currentTarget.dataset.type != "submit" &&
      $("#attachment-previews .reply-msg").length == 0
    ) {
      event.preventDefault();
      return false;
    }
    if (!this.attachmentsReady()) {
      event.preventDefault();
      this.showAlert("Upload in progress", "Please wait for all attachments to finish uploading.", "info");
      return false;
    }
    $(".form-actions").removeClass("d-none");
    this.updatePreviewBoxPosition(false);
  }

  removeLinkPreview(e) {
    const previewEle = e.target.closest(".preview-link");
    const linkThumb = previewEle.parentElement;
    const urlEle = linkThumb.nextElementSibling;
    urlEle.value = "";
    urlEle.nextElementSibling.value = false;
    previewEle.remove();
  }

  showAlert(title, message, icon) {
    Swal.fire({
      customClass: {
        popup:
          "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      title: title,
      text: message,
      icon: icon,
      confirmButtonText: "OK"
    });
  }

  updatePreviewBoxPosition(isBottomOffset) {
    $(".preview-box")
      .toggleClass("bottom-sm-90px", isBottomOffset)
      .toggleClass("bottom-0", !isBottomOffset);
  }

  disableButtons(add) {
    const messageAttachments = document.getElementById("messageAttachments");
    const msgGifPicker = document.getElementById("msgGifPicker");
    if (add) {
      messageAttachments.classList.add("disabled");
      msgGifPicker.classList.add("disabled");
    } else {
      messageAttachments.classList.remove("disabled");
      msgGifPicker.classList.remove("disabled");
    }
  }
}

const stopRecord = (record, mediaRecorder, stream) => {
  mediaRecorder.stop();
  if (stream?.getTracks()) for (const track of stream.getTracks()) {
    track.stop();
  }

  record.style.color = "";
  $(record)
    .find("i")
    .removeClass("fas text-primary")
    .addClass("far ri-play-fill");
  record.dataset.action = "click->message-preview#startAudio";
  $(".timer").remove();
  $("#attachment-previews button")[0].classList.remove("d-none");
};

const startRecord = (record, mediaRecorder) => {
  $(record).find("i").addClass("fas text-primary").removeClass("far");
  let htmlContent = `
<div class="timer text-center d-flex align-items-center justify-content-between gap-3" id="recorder">
  <div class="d-flex align-items-center gap-3 transparent-gradient p-3 rounded-3">
    <div class="d-flex align-items-center gap-1">
      ${[1, 3, 5, 2, 2, 4, 1, 3, 5, 2, 2, 4, 1, 3, 5, 2]
      .map(
        (n) =>
          `<div class="audio-bar bg-white animated-bar rounded-5 bar-${n}"></div>`
      )
      .join("")}
    </div>
    <div class="text-white min-w-50px text-end">
      <span class="minutes text-white">00</span>
      <span class="text-white">:</span>
      <span class="seconds text-white">00</span>
    </div>
  </div>
  <button id="stop-record" class="btn border-2 border-solid border-black bg-gradient-pink">
    <i class="ri-stop-fill"></i> Stop
  </button>
</div>
`;
  let preview = document.querySelector("#audio-recording-content");
  preview.innerHTML = htmlContent;
  mediaRecorder.start();
  record.dataset.action = "";
  timer();
};

const timer = () => {
  const minutes = document.querySelector(".minutes");
  const seconds = document.querySelector(".seconds");
  let timerTime = 0;

  const incrementTimer = () => {
    timerTime++;

    const numberMinutes = Math.floor(timerTime / 60);
    const numberSeconds = timerTime % 60;

    minutes.innerText = pad(numberMinutes);
    seconds.innerText = pad(numberSeconds);
  };

  const pad = (number) => {
    return number < 10 ? "0" + number : number;
  };

  setInterval(incrementTimer, 1000);
};

const uploadFile = (file) => {
  const input = document.getElementById("message_attachments");
  const url = input.dataset.directUploadUrl;
  console.log(url);
  const upload = new DirectUpload(file, url);
  upload.create((error, blob) => {
    if (!error) {
      const hiddenField = document.createElement("input");
      hiddenField.dataset.type = "hidden";
      hiddenField.dataset.value = blob.signed_id;
      hiddenField.name = input.name;
      let messageForm = document.getElementById("new_message");
      messageForm.appendChild(hiddenField);
    }
  });
};

function throwError(err) {
  let userMessage = "";

  switch (err.name) {
    case "NotAllowedError":
      userMessage =
        "You denied microphone access. Please allow microphone access in your browser settings and reload the page.";
      break;
    case "PermissionDeniedError":
      userMessage =
        "Microphone permission was denied. Check your browser permissions.";
      break;
    case "NotFoundError":
      userMessage = "No microphone found on your device.";
      break;
    case "NotReadableError":
      userMessage = "Your microphone is in use by another application.";
      break;
    case "AbortError":
      userMessage = "Could not access the microphone due to a system error.";
      break;
    default:
      userMessage = "Unable to access microphone. Please check your settings.";
  }
  alert(userMessage, 5000);
  if ($("#attachment-previews").find(".attachment-preview").length === 0)
    $("#attachment-previews").addClass("d-none");
  $("#audio-record-button").removeClass("disabled");
}

function generateUUID() {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }

  if (crypto?.getRandomValues) {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
      /[018]/g,
      (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
  }

  return "";
}
